import { setRegionDetailsData, resetRegionDetailsData } from '../../../redux/regionDetailsDataSlice';
import { SuccessfullModifyDialog } from '../../SuccessfullModifyDialog';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import  RegionDetailsContent from './regionDetailsContent';
import { useCallback, useEffect, useState } from 'react';
import RegionDetailsHeader from './regionDetailsHeader';
import { Box, CircularProgress } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import axios from 'axios';

const RegionDetails = () => {

    const { id } = useParams();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);

    const fetchRegionDetails = useCallback(async () => {
        try {
            const { data, status } = await axios.get(`region/${id}`);
            if ((status === 200 || status === 201) && data) {
                dispatch(setRegionDetailsData(data));
                setLoading(false);
            } else {
                setLoading(false);
                console.warn('Unexpected response status or empty data:', status, data);
            }
        } catch (error) {
            setLoading(false);
            console.error('Erreur lors de la récupération des informations de la region :', error);
            CustomErrorLogger(error, 'Erreur dans fetchPoleDetails');
        }
    }, [id, dispatch]);

    // Scroll to top on mount
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Fetch pole details on mount and cleanup on unmount
    useEffect(() => {
        fetchRegionDetails();
        return () => {
            dispatch(resetRegionDetailsData());
        };
    }, [fetchRegionDetails, dispatch]);

    return (
        <Box>
            {loading ?
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '80vh',
                    }}
                >
                    <CircularProgress
                        sx={{
                            '& .MuiCircularProgress-circle': { stroke: '#EA5E00' },
                        }}
                    />
                </Box>
                :
                <Box>
                    <RegionDetailsHeader />
                    <RegionDetailsContent />
                    <SuccessfullModifyDialog />
                </Box>
            }
        </Box>
    );
}

export default RegionDetails;